import { render, staticRenderFns } from "./ClipboardSegmentItems.vue?vue&type=template&id=17fd0ec2"
import script from "./ClipboardSegmentItems.vue?vue&type=script&lang=ts"
export * from "./ClipboardSegmentItems.vue?vue&type=script&lang=ts"
import style0 from "./ClipboardSegmentItems.vue?vue&type=style&index=0&id=17fd0ec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports